import appIcon from './app-icon.svg?sprite';
import arrowDownStrong2 from './arrow-down-strong-2.svg?sprite';
import arrowDownStrong from './arrow-down-strong.svg?sprite';
import arrowLargeBold from './arrow-large-bold.svg?sprite';
import arrowLarge from './arrow-large.svg?sprite';
import arrowLeft from './arrow-left.svg?sprite';
import arrowLightDown from './arrow-light-down.svg?sprite';
import arrowRight from './arrow-right.svg?sprite';
import arrowSmall from './arrow-small.svg?sprite';
import arrowStrongRight from './arrow-strong-right.svg?sprite';
import assortment2 from './assortment-2.svg?sprite';
import badge from './badge.svg?sprite';
import bin from './bin.svg?sprite';
import burger from './burger.svg?sprite';
import calendar from './calendar.svg?sprite';
import cameraOutline from './camera-outline.svg?sprite';
import cartUsp from './cart-usp.svg?sprite';
import cartWithPlus from './cart-with-plus.svg?sprite';
import checkboxActive from './checkbox/checkbox-active.svg?sprite';
import checkboxDefault from './checkbox/checkbox-default.svg?sprite';
import checkMarkSuccess from './checkmark-success.svg?sprite';
import clear from './clear.svg?sprite';
import clock from './clock.svg?sprite';
import closeSmall from './close-small.svg?sprite';
import close from './close.svg?sprite';
import copy from './copy.svg?sprite';
import cube from './cube.svg?sprite';
import defaultProductImage from './default-product-image.svg?sprite';
import discount from './discount.svg?sprite';
import document from './document.svg?sprite';
import edit from './edit.svg?sprite';
import email from './email.svg?sprite';
import emptyCart from './empty-cart.svg?sprite';
import emptyOrders from './empty-orders.svg?sprite';
import error from './error.svg?sprite';
import extraInfo from './extra-info.svg?sprite';
import facebook from './facebook.svg?sprite';
import filteringSorting from './filtering-sorting.svg?sprite';
import giftCard from './gift-card.svg?sprite';
import accountH24Large from './h24/account-large.svg?sprite';
import cartH24V2Large from './h24/cart-v2-large.svg?sprite';
import cartH24 from './h24/cart.svg?sprite';
import heart from './heart.svg?sprite';
import help from './help.svg?sprite';
import history from './history.svg?sprite';
import info from './info.svg?sprite';
import instagramFlat from './instagram-flat.svg?sprite';
import instagram from './instagram.svg?sprite';
import invisible from './invisible.svg?sprite';
import landscapeOutline from './landscape-outline.svg?sprite';
import lightCheck from './light-check.svg?sprite';
import link from './link.svg?sprite';
import list from './list.svg?sprite';
import location from './location.svg?sprite';
import login from './login.svg?sprite';
import logout from './logout.svg?sprite';
import marketplace from './marketplace.svg?sprite';
import materials from './materials.svg?sprite';
import megaphone from './megaphone.svg?sprite';
import message from './message.svg?sprite';
import minus from './minus.svg?sprite';
import myAccount from './myaccount.svg?sprite';
import negative from './negative.svg?sprite';
import neutral from './neutral.svg?sprite';
import parcel from './parcel.svg?sprite';
import pcUsp from './pc-usp.svg?sprite';
import phone from './phone.svg?sprite';
import pin from './pin.svg?sprite';
import pinterest from './pinterest.svg?sprite';
import play from './play.svg?sprite';
import plusFilled from './plus-filled.svg?sprite';
import plusStrong from './plus-strong.svg?sprite';
import positive from './positive.svg?sprite';
import printer from './printer.svg?sprite';
import profile from './profile.svg?sprite';
import qrCode from './qr-code.svg?sprite';
import question from './question.svg?sprite';
import radioDefault from './radio-default.svg?sprite';
import radioSelected from './radio-selected.svg?sprite';
import remove from './remove.svg?sprite';
import returnArrow from './return-arrow.svg?sprite';
import searchFillSmall from './search-fill-small.svg?sprite';
import search from './search.svg?sprite';
import security from './security.svg?sprite';
import shareArrow from './share-arrow.svg?sprite';
import share from './share.svg?sprite';
import size from './size.svg?sprite';
import sort from './sort.svg?sprite';
import sparkles from './sparkles.svg?sprite';
import spinner from './spinner.svg?sprite';
import starEmpty from './star-empty.svg?sprite';
import star from './star.svg?sprite';
import subscribe from './subscribe.svg?sprite';
import success from './success.svg?sprite';
import survey from './survey.svg?sprite';
import sustain from './sustain.svg?sprite';
import trophy from './trophy.svg?sprite';
import truckChristmas from './truck-christmas.svg?sprite';
import truckOlympic from './truck-olympic.svg?sprite';
import truck from './truck.svg?sprite';
import trustPilotStar from './trust-pilot-star.svg?sprite';
import trustShield from './trust-shield.svg?sprite';
import trust from './trust.svg?sprite';
import videoCall from './video-call.svg?sprite';
import visible from './visible.svg?sprite';
import voucher from './voucher.svg?sprite';
import warning from './warning.svg?sprite';
import wishlistFilled from './wishlist-filled.svg?sprite';
import wishlistV2FilledLarge from './wishlist-v2-filled-large.svg?sprite';
import wishlistV2Filled from './wishlist-v2-filled.svg?sprite';
import wishlistV2Large from './wishlist-v2-large.svg?sprite';
import wishlistV2 from './wishlist-v2.svg?sprite';
import wishlist from './wishlist.svg?sprite';
import zoom from './zoom.svg?sprite';

export default {
  accountH24Large,
  appIcon,
  badge,
  link,
  arrowLeft,
  arrowSmall,
  arrowRight,
  arrowLightDown,
  arrowDownStrong,
  arrowDownStrong2,
  arrowStrongRight,
  arrowLargeBold,
  assortment2,
  bin,
  burger,
  calendar,
  cameraOutline,
  cartUsp,
  cartWithPlus,
  cartH24,
  cartH24V2Large,
  checkboxActive,
  checkboxDefault,
  clear,
  clock,
  close,
  closeSmall,
  copy,
  cube,
  defaultProductImage,
  discount,
  document,
  edit,
  email,
  emptyCart,
  emptyOrders,
  error,
  extraInfo,
  facebook,
  filteringSorting,
  giftCard,
  positive,
  heart,
  history,
  info,
  invisible,
  instagram,
  instagramFlat,
  landscapeOutline,
  lightCheck,
  list,
  location,
  login,
  logout,
  marketplace,
  materials,
  megaphone,
  message,
  myAccount,
  negative,
  neutral,
  parcel,
  pcUsp,
  phone,
  pinterest,
  play,
  plusStrong,
  plusFilled,
  printer,
  radioDefault,
  radioSelected,
  returnArrow,
  search,
  searchFillSmall,
  security,
  sort,
  spinner,
  star,
  starEmpty,
  survey,
  sustain,
  trustPilotStar,
  subscribe,
  success,
  trophy,
  truck,
  truckChristmas,
  truckOlympic,
  trust,
  trustShield,
  videoCall,
  visible,
  warning,
  wishlist,
  wishlistFilled,
  wishlistV2,
  wishlistV2Filled,
  wishlistV2Large,
  wishlistV2FilledLarge,
  size,
  checkMarkSuccess,
  zoom,
  qrCode,
  share,
  shareArrow,
  pin,
  minus,
  sparkles,
  arrowLarge,
  remove,
  profile,
  voucher,
  help,
  question,
};
